import { IndexedDbCollectionRepository, IndexedDbDataAccess, IndexedDbDictionaryRepository } from '@softline/core';
import { SOFTLINE_NAME_USER_INDEXED_DB } from '@softapps/core';

export abstract class UserIndexedDbDictionaryRepository<TItem> extends IndexedDbDictionaryRepository<TItem, {userId: number}> {

  protected constructor(dataAccess: IndexedDbDataAccess,
                        objectStoreName: string) {
    super(dataAccess, SOFTLINE_NAME_USER_INDEXED_DB, objectStoreName)
  }
}
